import { render, staticRenderFns } from "./lazyblock_partners.vue?vue&type=template&id=31f8556b&scoped=true"
import script from "./lazyblock_partners.vue?vue&type=script&lang=js"
export * from "./lazyblock_partners.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_partners.vue?vue&type=style&index=0&id=31f8556b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8556b",
  null
  
)

export default component.exports